import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import FoodTracker from '../FoodTracker';

const FoodDashboard: React.FC = () => {
    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Food Distribution Dashboard
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" paragraph>
                    Manage food inventory and coordinate distribution to hunger zones.
                </Typography>

                <Paper elevation={3} sx={{ p: 0, mt: 3, overflow: 'hidden' }}>
                    <FoodTracker />
                </Paper>
            </Box>
        </Container>
    );
};

export default FoodDashboard; 